<template>
  <validation-observer ref="formRef" novalidate tag="form">
    <div class="px-3 pt-3">
      <div class="d-flex align-items-center mb-3 pt-2">
        <img
          alt=""
          class="mr-2"
          src="@/assets/img/file-plus-circle.svg"
          style="width: 20px; height: 20px"
        />
        <span class="color-black font-18 font-weight-bold">
          {{ isEditMode ? 'Editar Voucher de Pago' : 'Añadir Voucher de Pago' }}
        </span>
      </div>
      <div class="row">
        <div class="col-12 col-md-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              id="voucherNumber"
              v-model="form.voucherNumber"
              custom-error-msg="El campo es requerido"
              :error="errors[0]"
              label="Número de Voucher:"
              placeholder="Ingrese número de voucher"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-4 mt-3 mt-md-0">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-date-picker
              id="voucherDate"
              v-model="form.voucherDate"
              class-container="w-100"
              custom-error-msg="El campo es requerido"
              :error="errors[0]"
              label="Fecha de Voucher:"
              placeholder="DD/MM/YYYY"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-3 pb-3">
        <div class="col-12 d-flex justify-content-end">
          <action-button
            i="fas fa-times-circle"
            variant="outline-danger px-3 mr-2"
            @click="onCancel"
          >
            Cancelar
          </action-button>
          <action-button i="fas fa-save" variant="success px-3" @click="onSave">
            Guardar
          </action-button>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import CustomDatePicker from 'custom-date-picker';
import ActionButton from 'ActionButton';

export default {
  name: 'AddPaymentVoucher',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomInput,
    CustomDatePicker,
    ActionButton,
  },
  props: {
    initialVoucherNumber: {
      type: String,
      default: null,
    },
    initialVoucherDate: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      form: {
        voucherNumber: this.initialVoucherNumber,
        voucherDate: this.initialVoucherDate,
      },
    };
  },
  computed: {
    isEditMode() {
      return !!this.initialVoucherNumber;
    },
  },
  methods: {
    async onSave() {
      const isValid = await this.$refs.formRef.validate();
      if (!isValid) return;
      this.$emit('on-save', { ...this.form });
    },
    onCancel() {
      this.$refs.formRef.reset();
      this.form = { voucherNumber: null, voucherDate: null };
      this.$emit('on-cancel');
    },
  },
};
</script>
